import { useTranslation } from "react-i18next";
import { ScrollableContainer, StyledPageWrapper, Title } from "@monorepo/components";

import GsmSingleVoucher from "components/Services/GsmSingleVoucher";
import { PageWrapper } from "components/Services/ServicesPage";

interface IMyGsmVoucher {
  voucherId: string;
}

const MyGsmVoucher: React.FC<IMyGsmVoucher> = ({ voucherId }) => {
  const { t } = useTranslation();
  return (
    <StyledPageWrapper>
      <PageWrapper>
        <Title>{t("gsmVoucherServices.my_codes")}</Title>
        <ScrollableContainer>
          <GsmSingleVoucher voucherId={voucherId} />
        </ScrollableContainer>
      </PageWrapper>
    </StyledPageWrapper>
  );
};

export default MyGsmVoucher;
